import React, { useState, useEffect } from 'react';
import ChatThread from '../../components/Chat/ChatThread';
import MessageInput from '../../components/Chat/MessageInput';
import api from '../../services/api';

export default function Tickets({ caseId, currentUser }) {
  const [cannedMessages, setCannedMessages] = useState([]);
  const [messageKey, setMessageKey] = useState(0);

  useEffect(() => {
    fetchCannedMessages();
  }, []);

  const fetchCannedMessages = async () => {
    try {
      const data = await api.messages.getCanned();
      setCannedMessages(data);
    } catch (error) {
      console.error('Failed to fetch canned messages:', error);
    }
  };

  const handleMessageSent = () => {
    setMessageKey((prev) => prev + 1);
  };

  return (
    <div className="tickets-container">
      <div className="chat-container">
        <ChatThread key={messageKey} caseId={caseId} currentUser={currentUser} />
        <MessageInput
          caseId={caseId}
          onMessageSent={handleMessageSent}
          cannedMessages={cannedMessages}
        />
      </div>
    </div>
  );
}
